var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('Toolbar',{attrs:{"toolbarTitle":_vm.$t('Gruppenforen Antworten'),"tooltipMessage":_vm.$t('Auf dieser Seite haben Sie Überblick auf Thema Rückmeldungen'),"showDrawer":false,"lastPath":{ name: 'groupForumThreads' }}}),_c('v-container',[_c('AnswerList')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }